import { DragEvent, memo, useCallback } from 'react';
import { StackedCalendarMode } from '../Calendar.types';
import DayCellRenderer from './days/DayCellRenderer';
import LeadView from './leads/LeadView';
import useLeadsForProperty from './leads/useLeadsForProperty';
import SeasonalRuleRowLayer from './seasonalRules/SeasonalRuleRowLayer';

type Props = {
  propertyUid: string;
  isUnitType: boolean;
  isUnit: boolean;
  mode: StackedCalendarMode;
  renderedDates: Date[];
  leftSpacerWidth: number;
  rightSpacerWidth: number;
  onDrop: () => void;
  onDragEnter: (e: DragEvent<HTMLDivElement>, propertyUid: string) => void;
};

const StackedCalendarBodyRow = ({
  propertyUid,
  isUnitType,
  isUnit,
  mode,
  renderedDates,
  leftSpacerWidth,
  rightSpacerWidth,
  onDrop,
  onDragEnter,
}: Props) => {
  const handleDragEnter = useCallback(
    (e: DragEvent<HTMLDivElement>) => onDragEnter(e, propertyUid),
    [onDragEnter, propertyUid],
  );
  const leads = useLeadsForProperty(propertyUid);

  return (
    <div
      className="stacked-calendar-body-row"
      data-row-property-uid={propertyUid}
      onDrop={onDrop}
      onDragEnter={handleDragEnter}
    >
      {leftSpacerWidth > 0 && (
        <div aria-hidden style={{ flex: `0 0 ${leftSpacerWidth}px` }} />
      )}
      {renderedDates.map((dayDate) => (
        <DayCellRenderer
          isUnit={isUnit}
          isUnitType={isUnitType}
          propertyUid={propertyUid}
          dayDate={dayDate}
          mode={mode}
          key={`${propertyUid}-row-cell-${dayDate.getTime()}`}
        />
      ))}
      {rightSpacerWidth > 0 && (
        <div aria-hidden style={{ flex: `0 0 ${rightSpacerWidth}px` }} />
      )}
      {leads.map((lead) => (
        <LeadView key={lead.uid} lead={lead} />
      ))}
      <SeasonalRuleRowLayer propertyUid={propertyUid} />
    </div>
  );
};

export default memo(StackedCalendarBodyRow);
